import http from "@/http/http-common";
const resource = "/api/frontend";
class RecruitsService {
    recruits() {
        return http.get(`${resource}/recruits`);
    }
}

export default new RecruitsService();